module.exports = __webpack_public_path__ + "img/circle_white_mobile.067add50.png";